import React from "react";
import ProductCard from "../../ProductCard";
import * as styles from "./Recommendations.module.scss";

const Recommendations = ({ colorCategory, productRelated }) => {
  return (
    <>
      {productRelated === undefined || productRelated.length === 0 ? null : (
        <div className={`${styles.main__container}`}>
          <h2>También puede interesarte</h2>
          <div className={styles.cards}>
            {productRelated.map((e, index) => (
              <>
                {index !== 0 && <div className={styles.divider}></div>}
                <ProductCard
                  key={e.id} 
                  name={e.name}
                  img={e.images[0]}
                  slug={e.slug}
                  color={colorCategory}
                  product_code={e.product_code}
                />
              </>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default Recommendations;
